import apiFetch from '../apiFetch'

export default function (subscriptionId, token, userId) {
  const queryParams = userId ? `userId=${userId}` : ''
  return apiFetch({ endPoint: `EventSubscription/${subscriptionId}?${queryParams}`, method: 'DELETE', body: null, token: token })
}
